var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"videoPlayerContainer"}},[_c('video',{ref:"videoDetail",staticClass:"video-js vjs-big-play-centered",attrs:{"id":"my-player","width":"100%","height":"100%"}}),_c('div',{attrs:{"id":"labelsContainer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }